export enum LoginRoutePathNames {
  LOGIN = 'login',
  PASSWORD_RESET = 'password-reset',
}
